import React from "react";

import './Step.scss';
import check from '../../../constants/images/check.svg'
import {useSelector} from "react-redux";

const Step = (props) => {
    const {isPreviewOpen} = useSelector(state => state.modalPreviewSelectedPhoto);

    const isCompleted = props.index + 1 <= props.completedSteps;

    return (
        <div className={props.length === 5 ?
            "stepBlock5" + (props.selected ? " selected" : "") :
            "stepBlock4" + (props.selected ? " selected" : "")}>
            <div className={`circleWrapper ${isPreviewOpen ? 'transparent' : ''}`}>
                <div className={`circle ${isCompleted ? "completed" : ""}`}>
                    <div className={`inner-circle ${isCompleted ? "completed" : ""}`}>
                        {
                            isCompleted &&
                            <img
                                style={{width: '15px'}}
                                src={check}
                                alt="check icon" className="checkIcon"
                            />
                        }
                    </div>
                </div>
            </div>
            <span className="span">{props.label}</span>
        </div>
    )
}

export default Step;
